var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const Moon = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M19.3087 13.1735C19.6859 12.9964 20.0882 13.3677 19.983 13.7711C19.6242 15.1447 18.919 16.4519 17.8334 17.5375C14.6094 20.7611 9.45186 20.8285 6.31137 17.6883C3.17088 14.5482 3.23945 9.38999 6.46337 6.16641C7.54905 5.08084 8.8553 4.37579 10.2301 4.01698C10.6335 3.91186 11.0038 4.31409 10.8278 4.69118C9.68271 7.13543 10.0587 10.063 11.9981 12.0022C13.9363 13.9425 16.8642 14.3185 19.3087 13.1735Z", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
